/**
 * @file: 提供统一的正则表达式
 */

// 验证座机电话号码
export const cellphone = /^(\d{3,4}-)\d{7,8}$/;

// 验证手机号码
export const telephone = /^1[0-9]{10}$/;

// 验证座机和手机号
export const phone = /^((\d{3,4}-)\d{7,8})|(1[3|4|5|7|8][0-9]{9})$/;

// 验证Email
export const email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

// 整数或者小数
export const integet_decimal = /^[0-9]+([.][0-9]+){0,1}$/;

// 只能输入数字
export const number = /^[0-9]*$/;

// 只能输入由26个英文字母组成的字符串
export const letter = /^[A-Za-z]*$/;

// 只能输入由26个大写英文字母组成的字符串
export const uppercase = /^[A-Z]*$/;

// 只能输入由26个小写英文字母组成的字符串
export const lowercase = /^[a-z]*$/;

// 只能输入由数字和26个英文字母组成的字符串
export const letter_number = /^[A-Za-z0-9]*$/;

// 只能输入汉字
export const chinese = /^[\u4e00-\u9fa5]{0,}$/;